<template>
  <div v-if="rc_section">
    <div class="rc-header" >
      <v-text-field
         v-model="heading2"
         label="Section Name"
         hide-details
         @blur="$emit('update:heading', heading2)"
      ></v-text-field>
    </div>


    <!--v-model="rc_section.section_name"-->


    <!--<v-layout class="rc-header" >-->
      <!--&lt;!&ndash;<v-flex shrink style="padding-top:12px">&ndash;&gt;-->
        <!--&lt;!&ndash;Section:&ndash;&gt;-->
      <!--&lt;!&ndash;</v-flex>&ndash;&gt;-->
      <!--<v-flex shrink  >-->
        <!--<v-text-field-->
           <!--style="padding-top:0px"-->
           <!--v-model="rc_section.section_name"-->
           <!--label="Section Name"-->
           <!--hide-details-->
        <!--&gt;</v-text-field>-->
      <!--</v-flex>-->
    <!--</v-layout>-->


    <draggable
            v-model="rc_section.questions"
            group="reportcard"
            @start="drag=true"
            @end="drag=false"
            @update="update_prop"
            @add="update_prop"
            @remove="update_prop"
            ghostClass="dragged"
            handle=".v-input__prepend-outer"
    >
      <v-layout v-for="(value, i) in rc_section.questions"  :key="'tq'+i">
        <v-flex xs5 >
          <v-autocomplete
                  :label="'Question ' + (i+1)"
                  :items="questions"
                  v-model="rc_section.questions[i].q_id"
                  item-text="question"
                  item-value="_id"
                  prepend-icon="sort"
                  hide-details
          ></v-autocomplete>

        </v-flex>
        <v-flex xs3  >
          <v-text-field
                  label="Display Text"
                  v-model="rc_section.questions[i].display_txt"
                  hide-details
          ></v-text-field>

        </v-flex>
        <v-flex xs2 >
          <v-autocomplete
                  label="Answer Display Type"
                  :items="['Percentages', 'Average']"
                  v-model="rc_section.questions[i].display_type"
                  hide-details
          ></v-autocomplete>

        </v-flex>
        <v-flex xs1  >
          <!--<v-text-field-->
                  <!--label="Benchmark Value"-->
                  <!--v-model="rc_list[i].benchmark"-->
                  <!--append-outer-icon="clear"-->
                  <!--@click:append-outer="rc_list.splice(i, 1)"-->
                  <!--hide-details-->
          <!--&gt;</v-text-field>-->
          <v-text-field
             label="Benchmark Value"
             v-model="rc_section.questions[i].benchmark"
             hide-details
          ></v-text-field>
        </v-flex>

        <v-flex xs1  >

          <v-checkbox
             class="mycheckbox"
             v-model="rc_section.questions[i].hide_NAs"
             style="margin-top:7px"
             label="Hide NA's"
             hide-details
          ></v-checkbox>

          <!--<div style="padding-top:0px">-->
            <!--<input type="checkbox" :id="heading +'-q'+i" style="width: 15px; height: 15px; color:red">-->
            <!--<span>-->
            <!--<div  style="padding-left:5px">-->
              <!--Show <br> NA-->
            <!--</div>-->
            <!--</span>-->

          <!--</div>-->

        </v-flex>

        <v-icon
           small
           style="margin-top: 5px;"
           @click="rc_section.questions.splice(i, 1)"

        >close</v-icon>

      </v-layout>

    </draggable>

    <v-layout>
      <v-flex grow></v-flex>
      <v-flex shrink>
        Add question
        <v-icon v-on:click="rc_section.questions.push({q_id: '', display_type: null, benchmark:'', display_txt: null})">add</v-icon>
      </v-flex>
    </v-layout>
  </div>
</template>

<style scoped>
  .dragged{
    background-color: #cbcbcb;
  }

  .rc-header{
    font-size: medium;
    font-weight: bold;
  }


  /*/deep/ .v-input .v-input--selection-controls .v-input--checkbox .v-input--hide-details .theme-light {*/
    /*margin-top: 0px;*/
  /*}*/

 .mycheckbox /deep/ .v-label{
  font-size: 12px;
}
</style>
<script>
   import draggable from 'vuedraggable'

   //TODO: note that we're directly modifying a prop which is unideal, however, given that the prop is an array, it still works.

   export default {
      components: {draggable},
      data(){
        return {

           heading2: this.heading,
        }
      },
      props: {
         // rc_list: Array,
         rc_section: {type: Object, default: () =>{}},
         questions: Array, // list of question to populate drop down with
         heading: String
      },

      watch:{

         heading(newVal){
            if (newVal !== this.heading){
               this.heading2 = this.heading;
            }
         },

      //    heading2(newVal){
      //       if (newVal !== this.heading){
      //          this.$emit('update:heading', this.heading2);
      //       }
      //    }


      },

      methods:{
         update_prop(){
            console.log('I RAN');
            this.$emit('update:rc_section', this.rc_section)
         },
      },

      mounted(){
         console.log('i ran')
         // this.heading2 = this.heading;
      }




   };
</script>
